module.exports = __webpack_public_path__ + "img/11_paul_h.20e6c005.png";